"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputOverlay = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _get = _interopRequireDefault(require("lodash/get"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _excluded = ["containerClassName", "inputClassName", "inputDataValue", "inputShownValue", "children", "inputRef", "onBlurFn", "onFocusFn", "idToIgnoreToggle", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var InputOverlay = exports.InputOverlay = /*#__PURE__*/function (_React$Component) {
  _inherits(InputOverlay, _React$Component);
  function InputOverlay(props) {
    var _this;
    _classCallCheck(this, InputOverlay);
    _this = _callSuper(this, InputOverlay, [props]);
    _this.state = {
      show: false
    };
    _this.openDropdown = _this.openDropdown.bind(_assertThisInitialized(_this));
    _this.closeDropdown = _this.closeDropdown.bind(_assertThisInitialized(_this));
    _this.toggleDropdown = _this.toggleDropdown.bind(_assertThisInitialized(_this));
    _this.onChangeActivity = _this.onChangeActivity.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(InputOverlay, [{
    key: "closeDropdown",
    value: function closeDropdown(e) {
      var idToIgnoreToggle = this.props.idToIgnoreToggle;
      var tag = (0, _get.default)(e, 'target.id', '');
      if (idToIgnoreToggle !== tag) {
        this.setState({
          show: false
        });
        if ((0, _isFunction.default)(this.props.onBlurFn)) this.props.onBlurFn();
      }
    }
  }, {
    key: "openDropdown",
    value: function openDropdown(e) {
      this.setState({
        show: true
      });
      if ((0, _isFunction.default)(this.props.onFocusFn)) this.props.onFocusFn(e);
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var show = this.state.show;
      this.setState({
        show: !show
      });
    }
  }, {
    key: "onChangeActivity",
    value: function onChangeActivity(e) {
      if (e.target.value && !this.state.show) {
        this.openDropdown(e);
      }
      this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        containerClassName = _this$props.containerClassName,
        inputClassName = _this$props.inputClassName,
        inputDataValue = _this$props.inputDataValue,
        inputShownValue = _this$props.inputShownValue,
        children = _this$props.children,
        inputRef = _this$props.inputRef,
        onBlurFn = _this$props.onBlurFn,
        onFocusFn = _this$props.onFocusFn,
        idToIgnoreToggle = _this$props.idToIgnoreToggle,
        onChange = _this$props.onChange,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var show = this.state.show;
      var listComponent = /*#__PURE__*/_react.default.cloneElement(children, {
        listToggle: this.toggleDropdown
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-container ".concat(containerClassName || '')
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        "aria-haspopup": "true",
        tabIndex: "0",
        type: "text",
        className: "form-control ".concat(inputClassName || ''),
        onFocus: this.openDropdown,
        ref: inputRef,
        value: inputShownValue,
        "data-value": inputDataValue,
        autoComplete: "off",
        onChange: this.onChangeActivity
      }, rest)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Overlay, {
        container: this,
        show: show,
        placement: "bottom",
        target: this.target,
        onHide: this.closeDropdown,
        rootClose: true
      }, /*#__PURE__*/_react.default.createElement("div", null, listComponent)));
    }
  }]);
  return InputOverlay;
}(_react.default.Component);
InputOverlay.propTypes = {
  showOverlay: _propTypes.default.bool,
  inputDataValue: _propTypes.default.string,
  inputShownValue: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  children: _propTypes.default.object.isRequired,
  inputRef: _propTypes.default.func,
  onFocusFn: _propTypes.default.func,
  onBlurFn: _propTypes.default.func,
  onChange: _propTypes.default.func,
  idToIgnoreToggle: _propTypes.default.string
};